<template>
    <v-table
        :desktop-headers="['ID', 'Откуда', 'Куда', 'Сумма', 'Комментарий', 'Дата']"
        :mobile-headers="['Откуда', 'Куда', 'Сумма']"
        :items="tableData"
    >
        Откуда Куда СуммаОткуда СуммаКуда коммент дата
        <!--        @paginate="onload"-->
        <template #desktop="item">
            <td>{{ item.id }}</td>
            <td>{{ item.from }}</td>
            <td>{{ item.to }}</td>
            <td>{{ item.amount }}</td>
            <td>{{ item.comment }}</td>
            <td>{{ item.created_at }}</td>
        </template>

        <template #mobileHeader="item">
            <v-table-mobile-header>
                {{ item.from }}
            </v-table-mobile-header>
            <v-table-mobile-header>
                {{ item.to }}
            </v-table-mobile-header>
            <v-table-mobile-header>
                {{ item.amount }}
            </v-table-mobile-header>
        </template>

        <template #mobile="item">
            <v-table-mobile-item title="ID">
                {{ item.id }}
            </v-table-mobile-item>
            <v-table-mobile-item title="Комментарий">
                {{ item.comment }}
            </v-table-mobile-item>
            <v-table-mobile-item title="Дата">
                {{ item.created_at }}
            </v-table-mobile-item>
        </template>
    </v-table>
</template>

<script>
import { api } from "@/updated/modules/admin/pages/forex-finances/services";

export default {
    name: "AccountTransactionsPage",
    data() {
        return {
            tableData: []
        };
    },
    created() {
        api.getUsersAccountTransactions(this.$route.params.id).then(data => {
            this.tableData = data;
        });
    }
};
</script>

<style scoped></style>
